// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__IXb8k","nav-item":"nav_nav-item__5PTF7","nav-i18n":"nav_nav-i18n__A+Dah","lang":"nav_lang__JfJRc","lang-item":"nav_lang-item__wDxPu"};